import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetCanalDonation from './met-canal-donation';
import MetCanalDonationDetail from './met-canal-donation-detail';
import MetCanalDonationUpdate from './met-canal-donation-update';
import MetCanalDonationDeleteDialog from './met-canal-donation-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetCanalDonationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetCanalDonationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetCanalDonationDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetCanalDonation} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetCanalDonationDeleteDialog} />
  </>
);

export default Routes;
